import { render, staticRenderFns } from "./PurchaseRequisitionFormLine.vue?vue&type=template&id=a497978c"
import script from "./PurchaseRequisitionFormLine.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionFormLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports